import type { FeatureActiveType } from './FeatureActive';

export const defaultState: Fields = {
  features: {},
};

export interface Fields {
  features: Record<string, FeatureActiveType>;
}
